import e from "./_createEscaper.js";
import a from "./_unescapeMap.js";
var r = e(a);
export { r as default };